module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Dunkirk_.048e82b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Dunkirk_.jpg
// module id = emgU
// module chunks = 0